<template>
    <ModalWrapper
        v-model="dialog"
        transition="dialog-center-transition"
        :subtitle="$t('check_the_filters')"
        :fullscreen="$breakpoint.smAndDown"
        scrollable
    >
        <template v-slot:activator="{props}">
            <v-btn
                data-cy="configure-filters"
                density="compact"
                variant="text"
                icon="mdi-circle-edit-outline"
                v-bind="props"
                @click="dialog = true"
            />
        </template>
        <template v-slot:title>
            {{ $t('configure_filters_for_reservations') }}
        </template>
        <template v-slot:content>
            <template v-for="item in filtersCloned" :key="item.value">
                <v-checkbox
                    v-model="item.show"
                    :data-cy="`check-filter-${item.value}`"
                    :label="item.label"
                    density="compact"
                    hide-details
                />
            </template>
        </template>
        <template v-slot:btns>
            <v-btn
                data-cy="save-configure-filters"
                :loading="isLoading"
                :disabled="isLoading"
                variant="flat"
                @click="save"
            >
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Prop, Emit, Vue, Watch} from 'vue-facing-decorator'

    @Component({
        components: {},
    })
    export class ReservationsFiltersConfigurationModal extends Vue {
        @Prop({required: true}) filtersList

        dialog = false
        isLoading = false

        filtersCloned = []

        @Watch('filtersList', {immediate: true})
        onFiltersChange() {
            this.filtersCloned = [...this.filtersList]
        }

        @Emit()
        change(filters) {
            return filters
        }

        async save() {
            this.isLoading = true
            try {
                const filters = []
                this.filtersCloned.forEach(item => {
                    if (!item.show) filters.push(item.value)
                })
                await this.$api.reservationsFiltersConfiguration.post({userId: this.userId, filters})
                this.change(filters)
                this.dialog = false
                // eslint-disable-next-line no-empty
            } catch (e) {}
            this.isLoading = false
        }

        get userId() {
            return authStore.person.personId
        }
    }

    export default ReservationsFiltersConfigurationModal
</script>
